import React, { useState } from "react"
import PropTypes from 'prop-types'
import { Dropdown, Avatar, Typography } from "antd"
import { UserOutlined, PoweroffOutlined } from "@ant-design/icons"
import { createImageFromInitials, getRandomColor } from "../../../helpers/create_avatar"
import { withTranslation } from "react-i18next"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import { getApiUrlUserFiles } from "common/global"
import { getCurrentUser } from "helpers/service_helper"

const ProfileMenu = props => {
  const user = getCurrentUser()
  const displayName = user?.name || "کاربر"
  const [avatarSrc, setAvatarSrc] = useState(
    user?.sid ? getApiUrlUserFiles(`${user.sid}/PicPersonal.jpg`) : undefined
  )

  const items = [
    {
      key: "profile",
      label: (
        <span>
          <UserOutlined className="me-2" /> {props.t("Profile")}
        </span>
      ),
    },
    {
      type: "divider",
    },
    {
      key: "logout",
      danger: true,
      label: (
        <span>
          <PoweroffOutlined className="me-2" /> {props.t("Logout")}
        </span>
      ),
    },
  ]

  const onMenuClick = ({ key }) => {
    if (key === "profile") {
      props.history.push("/profile")
    }
    if (key === "logout") {
      props.history.push("/logout")
    }
  }

  return (
    <Dropdown
      trigger={["click"]}
      placement="bottomRight"
      menu={{ items, onClick: onMenuClick }}
    >
      <div style={{ display: "inline-flex", alignItems: "center", cursor: "pointer" }}>
        <Avatar
          size={32}
          src={avatarSrc}
          onError={() => {
            setAvatarSrc(createImageFromInitials(32, displayName, getRandomColor()))
            return false
          }}
        >
          {displayName?.charAt(0) || <UserOutlined />}
        </Avatar>
        <Typography.Text style={{ marginInlineStart: 8 }} className="d-none d-md-inline">
          {displayName}
        </Typography.Text>
      </div>
    </Dropdown>
  )
}

ProfileMenu.propTypes = {
  success: PropTypes.any,

  t: PropTypes.any
}

const mapStatetoProps = state => {
  const { error, success } = state.Profile
  return { error, success }
}

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
)
